import { type MouseEventHandler, type ReactNode, useEffect } from 'react';

import { Text } from '@revelio/ui';

import {
  type ChartError,
  useReportChartError,
} from '../AIBuilder/ChartErrorContext';
import styles from './chart-status.module.css';

const MESSAGE = 'No data available for selected metrics or filters';

interface ChartNotSupportedProps {
  children?: ReactNode;
  /** Error details for AI auto-fix reporting */
  errorDetails?: Omit<ChartError, 'timestamp'>;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const ChartNotSupported = ({
  children,
  errorDetails,
  onClick,
}: ChartNotSupportedProps) => {
  const reportError = useReportChartError();

  // Report error to context when mounted with error details
  useEffect(() => {
    if (errorDetails) {
      reportError(errorDetails);
    }
  }, [errorDetails, reportError]);

  return (
    <div
      data-testid="chart-not-supported"
      className={styles.notSupported}
      onClick={onClick}
    >
      <Text className={styles.notSupportedText}>{children || MESSAGE}</Text>
    </div>
  );
};
